module.exports = __webpack_public_path__ + "static/googlebadge-7f7c2f55ef6d2fc52825525345452f11.svg";